module.exports = __webpack_public_path__ + "static/img/01.710d5c62.png";